module.exports = __webpack_public_path__ + "static/img/hair_14.a107f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_14.png
// module id = EaRI
// module chunks = 0